// extracted by mini-css-extract-plugin
export default {"cover":"image_cover__Dx+1Q","picker":"image_picker__+T0nB","label":"image_label__HEYkl","additional":"image_additional__9vooj","chroma":"image_chroma__ERMX1"};